<div *ngIf="message.attachments" class="attachments">
  <ng-container *ngFor="let attachment of message.attachments.getAttachments()">
    <!-- Do not display the BZC Maps Rich link preview -->
    <app-attachment-thumbnail
      *ngIf="attachment.type !== AttachmentType.BZCSplittableRichLink"
      [attachment]="attachment"
      [canBeRemoved]="true"
      (removedClicked)="removeAttachment(attachment)"
      (copyAttachmentText)="copyAttachmentText(attachment)"></app-attachment-thumbnail>
  </ng-container>
</div>
<ion-progress-bar
  *ngIf="message.attachments && message.attachments.uploading$ | async"
  [value]="message.attachments.uploadProgress$ | async"></ion-progress-bar>

<textarea
  *ngIf="!codedmirrorContext.isCodeMirror"
  appTextareaAutoExpand
  [ngModel]="message.text"
  (ngModelChange)="onTextAreaChanged($event)"
  [scrollContainer]="scrollContainer"
  [shouldAdjustPageScroll]="!editorConfig.useTwitterPublicEditor"
  (focus)="onTextareaFocused($event)"
  class="alc-editor-textarea"></textarea>
<div *ngIf="codedmirrorContext.isCodeMirror">
  <app-favorite-suggestion
    *ngIf="codedmirrorContext.shouldSuggestFavorites(favorites) && !shouldDisplayAIAssistantResponse()"
    [favorites]="favorites"
    [codemirrorContext]="codedmirrorContext"
    (favoriteSelected)="fillAnswerEditorWithFavorite($event, true)"></app-favorite-suggestion>
  <app-ai-assistant-suggestion
    *ngIf="shouldDisplayAIAssistantResponse()"
    [taskId]="taskId"
    [codemirrorContext]="codedmirrorContext"
    (answerAccepted)="fillAnswerEditorWithAIAssistantAnswer($event, true)"
    (answerRejected)="rejectAnswerEditorWithAIAssistantAnswer($event)">
  </app-ai-assistant-suggestion>
  <app-codemirror-wrapper
    [(ngModel)]="message.text"
    [ctx]="codedmirrorContext"
    (focus)="onCodeMirrorFocused()"
    [class.invalid]="isPublish && !message.isValid()"
    (ngModelChange)="onTyping($event)"></app-codemirror-wrapper>
</div>

<div [hidden]="!message.isFocused" class="buttons-line">
  <app-codemirror-spellchecker
    *ngIf="codedmirrorContext.isSpellCheckerEnabled"
    [editorConfig]="editorConfig"
    [codemirrorContext]="codedmirrorContext"></app-codemirror-spellchecker>
  <ion-button
    [attr.data-testid]="button.icon"
    *ngFor="let button of userPlaceholderAndFavoritesAndAttachmentButtons$ | async"
    (click)="button.handler($event)"
    size="small"
    fill="clear"
    class="add-attachment-button"
    [matTooltip]="button.tooltip | translate">
    <ion-icon *ngIf="button.icon" slot="icon-only" [name]="button.icon"></ion-icon>
    <ion-icon *ngIf="button.iconUrl" slot="icon-only" [src]="button.iconUrl"></ion-icon>
  </ion-button>
  <ion-button
    *ngIf="editorConfig.useTwitterPublicEditor"
    (click)="toggleDMSwitch()"
    [matTooltip]="toggleDMSwitchTooltipKey() | translate"
    [class.checked]="message.isDMSwitchChecked"
    size="small"
    fill="clear"
    class="add-attachment-button toggle-button">
    <span>→DM</span>
  </ion-button>
  <ion-button
    *ngIf="shouldShowLinkShortenerSwitch()"
    (click)="toggleLinkShortenerSwitch()"
    [matTooltip]="toggleLSSwitchTooltipKey() | translate"
    [class.checked]="message.areLinkedShortened"
    size="small"
    fill="clear"
    class="add-attachment-button toggle-button">
    <span>alc.cx</span>
  </ion-button>
  <span class="alc-spacer"></span>
  <span
    *ngIf="editorConfig.hasMaxCharsNumber || editorConfig.hasMaxUTF8BytesNumber"
    [ngClass]="{ 'message-is-too-long': message.isMessageTooLong }"
    class="characters-counter">
    {{ message.remainingCharsNumber }}
  </span>
  <ng-container *ngIf="editorConfig.useTwitterPublicEditor">
    <ion-button
      (click)="message.addMessage()"
      [matTooltip]="'m/task-process/twitter-public/add-single-message' | translate"
      size="small"
      fill="clear"
      class="add-attachment-button">
      <ion-icon slot="icon-only" name="add"></ion-icon>
    </ion-button>
    <ion-button
      *ngIf="!message.isOnlyMessage"
      (click)="message.removeMessage()"
      [matTooltip]="'m/task-process/twitter-public/remove-single-message' | translate"
      size="small"
      fill="clear"
      class="add-attachment-button">
      <ion-icon slot="icon-only" name="trash"></ion-icon>
    </ion-button>
  </ng-container>
</div>
<input #fileInput (change)="onFileSelected($event)" hidden type="file" />
<div id="{{ message.attachments.uploadByChunkHelper.getDivRandomIdentifier() }}"></div>
